module.exports = __webpack_public_path__ + "static/media/10.c5382dc8.jpg";